module.exports = __webpack_public_path__ + "img/46.61df96e4.gif";